import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SimpleAuthShell, primaryBtn } from "@/components/SimpleAuthShell";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token");

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Les mots de passe ne correspondent pas");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Mot de passe modifié. Connectez-vous.");
      nav("/connexion");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <SimpleAuthShell title="Nouveau mot de passe">
      {!token ? (
        <p className="text-red-700 font-semibold" data-testid="reset-invalid">Lien invalide.</p>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <div className="space-y-2">
            <Label htmlFor="pw">Nouveau mot de passe</Label>
            <Input id="pw" type="password" minLength={6} required className="h-12 text-base" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="pw2">Confirmer</Label>
            <Input id="pw2" type="password" minLength={6} required className="h-12 text-base" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" />
          </div>
          <button type="submit" disabled={busy} className={primaryBtn} data-testid="reset-submit-btn">
            {busy && <Loader2 className="w-5 h-5 animate-spin" />} Valider
          </button>
        </form>
      )}
    </SimpleAuthShell>
  );
}
